export const HOST = "https://alisher-sk.onrender.com"